import React, {useState} from 'react';
import './AddInputFormsForTroubles.scss';
import { setViewAnswerForTroubles} from '../troubleslice';
import { idAnswerOnTroubleCreate} from '../../../Admin/adminSlice';

const AddAnswerForTroubles = (props) => {

            
  const [inputContent, setInputContent] = useState();        
  const { dispatch } = props;
  
    // CLICK OK
    const onSend =() => {
        
          const item = {
            troubleId: props.selectedTroubleId,
            
            textAnswer: inputContent,
            userId: props.userId,
            imgPath: null,
               
            }
            console.log(item);
            dispatch(idAnswerOnTroubleCreate(item));
            dispatch(setViewAnswerForTroubles());  
            
    }
    // ENTER INPUT
    const handleInputContent =(e)=> {
        setInputContent(e.target.value);
            
    }





    // CLOSE FORM
    const onClose=()=> {
    
     dispatch(setViewAnswerForTroubles());

    }

    
        
            //console.log(this.props.adminState.openInputForms);
       // if (props.adminState.openAddInputFormsForAnswers) {
            return(
                <div className="AddInputFormsForTroubles ">
                            


                
                <form>
                <p>Ответ:</p>
                    <label>
                        
                    <textarea  onChange={handleInputContent} 
                    ></textarea>
                    </label>

                </form>
                <button onClick={onSend}>Отправить</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
       // } else return null;
        
        

            
    
}
export default AddAnswerForTroubles;